// Privacy_en.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Privacy() {
  return (
    <div className="terms-page">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/en" className="brand-link" aria-label="Go to main page">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="privacy-title">
        <article className="generator-card terms-card" aria-labelledby="privacy-title">
          <header className="terms-header">
            <h1 id="privacy-title" className="card-title">TooLoves.net Privacy Policy</h1>
            <p className="card-subtitle terms-updated">
              Last updated:
              <time dateTime="2025-10-22"> October 22, 2025 (KST)</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              This Privacy Policy (the “Policy”) explains how the operator of TooLoves.net (the “Site”)
              handles users’ personal information. By using the Site, you are deemed to have agreed to this Policy.
            </p>
          </section>

          <section className="terms-section" id="info-collection">
            <h2 className="section-title">1. Information We Collect</h2>
            <p>
              The Site does not directly collect personally identifiable information (e.g., name, email address, IP address).
              All features—such as QR code generation, image watermarking, and EXIF extraction—are processed on your device.
              Images or data are not uploaded or transmitted to our servers.
            </p>
            <p>
              However, to improve service quality and analyze usage, the Site uses
              <strong> Google Analytics (GA4)</strong>. Google may automatically collect
              <strong> non-identifiable data</strong> using cookies, such as device information, visited pages, time on page,
              click events, browser type, and approximate location (city-level).
              This data cannot identify individuals and is used only for site operation and service improvement.
            </p>
          </section>

          <section className="terms-section" id="use-of-info">
            <h2 className="section-title">2. Purpose of Use</h2>
            <p>
              The collected data is used solely for statistical purposes such as traffic analysis, error diagnostics,
              and service improvement. The Site adheres to the policies of Google Analytics (GA4), Netlify, and Google AdSense.
            </p>
          </section>

          <section className="terms-section" id="data-sharing">
            <h2 className="section-title">3. Provision and Sharing of Data</h2>
            <p>
              The Site does not directly collect or store personal information.
              However, automatic data collection may occur through Netlify, Google AdSense, and Google Analytics,
              which are used to provide the service. Any such data is managed in accordance with each provider’s privacy policy.
            </p>
          </section>

          <section className="terms-section" id="data-security">
            <h2 className="section-title">4. Data Security</h2>
            <p>
              The Site does not store personal information. The infrastructure required to operate the Site follows
              <strong> Netlify</strong>’s security policies. Advertising and analytics are subject to the security frameworks of
              <strong> Google AdSense</strong> and <strong> Google Analytics</strong>.
            </p>
            <p>
              You can refuse the use of cookies via your browser settings, or install the
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Analytics Opt-out Browser Add-on
              </a>
              to disable data collection.
            </p>
          </section>

          <section className="terms-section" id="policy-changes">
            <h2 className="section-title">5. Changes to This Policy</h2>
            <p>
              We may amend this Privacy Policy as needed. When changes occur, we will provide notice on the Site or on this page.
            </p>
            <p>
              Your continued use of the service after changes are posted will be deemed your acceptance of the revised Policy.
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">6. Contact</h2>
            <p>
              For service-related inquiries, please contact{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="Send email to helptooloves@gmail.com"
              >
                helptooloves@gmail.com
              </a>.
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/en" className="btn" aria-label="Back to main page">
              Back to main page
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">
        © 2025 TooLoves. All rights reserved.
      </footer>
    </div>
  );
}

export default Privacy;